// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3WhVV","legacyBtn":"MutateMid_legacyBtn__1M70P"};